/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes, supports } = metadata;

const settings = {
	title: __( 'Container' ),
	description: __( 'Gutenify Container.' ),
	icon: <Icon icon="plus-alt" />,
	keywords: [
		'gutenify',
		__( 'container' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save,
	supports,
};

export { name, category, settings };
